import React, { PureComponent } from 'react';
import Mediator from '../../services/Mediator';
import classnames from 'classnames';
import Login from '../login';

import './reconnect.css';

class Reconnect extends PureComponent {
    constructor(props, ...args) {
        super(props, ...args);

        this.state = {
            visible: false
        };

        this.resumePendingRequest = null;

        Mediator.add(this);

        this.clearConnectionError = this.clearConnectionError.bind(this);
    }
    componentWillUnmount() {
        Mediator.remove(this);
    }
    onConnectionTimeout(resumePendingRequest) {
        this.resumePendingRequest = resumePendingRequest;
        this.setState({ visible: true });
    }
    clearConnectionError() {
        this.setState({ visible: false });
        this.resumePendingRequest();
    }
    render() {
        let { visible } = this.state;
        let classes = classnames({
            'reconnect': true,
            visible
        });
        return (<div className={ classes }>
            <div className="modal">
                <div className="icons">
                    <span className="fa fa-laptop"></span>
                    <span className="fa fa-chain-broken throb"></span>
                    <span className="fa fa-cloud"></span>
                </div>
                <Login visible={true} onLoggedIn={ this.clearConnectionError } />
            </div>
        </div>);
    }
}

export default Reconnect;


// WEBPACK FOOTER //
// ./src/components/reconnect/index.js